import TraindGraphRsService from '@/services/TraindGraphRsService'

export const getPlaces = () => TraindGraphRsService.get('/place')

export const getShortestPath = ({ from, to, via }) =>
TraindGraphRsService.get(
    `/direction?from=${from}&to=${to}${via.length ? `&via=${via}` : ''}`
  )
